export enum DistrictFilterTargetEntityNames {
  EVENTS = 'events',
  HOSPITALS = 'hospitals',
}

export const QUERY_KEY_DISTRICT_FILTER_TARGET_ENTITY_NAME = 'target'

/**
 * TODO: 아래 code들을 제공해주는 API가 존재하나 user 정보가 없을시 데이터를 얻을 수 없습니다.
 * API가 non-user 에게도 제공되도록 API 스팩이 변경되면, 아래 code들을 삭제하고 동적으로 부르는 방식을 사용합니다.
 */
export const SEARCH_DISTRICT_CODES_FOR_KO_USER = [
  'N1101',
  'N1102',
  'N1103',
  'N1104',
  'N1105',
  'N1106',
  'N1107',
  'N1108',
  'N1109',
  'N1110',
  'N1111',
  'N1112',
  'N1113',
  'N1114',
  'N1115',
  'N1116',
  'N1117',
  'N1118',
  'N1119',
  'N1120',
  'N1121',
  'N1201',
  'N1202',
  'N1203',
  'N1204',
  'N1205',
  'N1206',
  'N1207',
  'N1208',
  'N1209',
  'N1210',
  'N1211',
  'N1212',
  'N1213',
  'N1214',
  'N1301',
  'N1302',
  'N1303',
  'N1304',
  'N1305',
  'N1306',
  'N1401',
  'N1402',
  'N1403',
  'N1404',
  'N1405',
  'N1406',
  'N1501',
  'N1502',
  'N1503',
  'N1504',
  'N1505',
  'N1506',
  'N1507',
  'N1508',
  'N1601',
  'N1602',
  'N1603',
  'N1604',
  'N1701',
  'N1702',
  'N1703',
  'N1704',
  'N1801',
  'N1802',
  'N1901',
  'N1902',
  'N1903',
  'N1904',
  'N1905',
  'N1906',
  'N1907',
  'N2001',
  'N2002',
  'N2003',
  'N2004',
  'N2005',
  'N2101',
  'N2102',
  'N2103',
  'N2104',
  'N2105',
  'N2106',
  'N2107',
  'N2201',
  'N2202',
  'N2203',
  'N2204',
  'N2205',
  'N2301',
  'N2302',
  'N2303',
  'N2304',
  'N2305',
  'N2306',
  'N2307',
  'N2308',
  'N2401',
  'N2402',
  'N2403',
  'N2404',
  'N2405',
  'N2406',
  'N2407',
  'N2501',
  'N2502',
  'N2503',
  'N2504',
  'N2505',
  'N2506',
  'N2507',
  'N2508',
  'N2509',
  'N2601',
  'N2602',
]

export const SEARCH_DISTRICT_CODES_FOR_JP_USER = [
  'N5001',
  'N5002',
  'N5003',
  'N5004',
  'N5005',
  'N5006',
  'N5007',
  'N5008',
  'N5009',
  'N5010',
  'N5011',
  'N5012',
  'N5013',
  'N5014',
  'N5015',
  'N5016',
  'N5017',
  'N5018',
  'N5019',
  'N5020',
  'N5021',
  'N5022',
  'N5023',
  'N5024',
  'N5025',
  'N5026',
  'N5027',
  'N5028',
  'N5029',
  'N5030',
  'N5031',
  'N5032',
  'N5033',
  'N5101',
  'N5102',
  'N5103',
  'N5104',
  'N5105',
  'N5106',
  'N5107',
  'N5108',
  'N5109',
  'N5110',
  'N5111',
  'N5112',
  'N5113',
  'N5114',
  'N5115',
  'N5116',
  'N5117',
  'N5118',
  'N5119',
  'N5120',
  'N5121',
  'N5122',
  'N5123',
  'N5124',
  'N5125',
  'N5126',
  'N5127',
  'N5128',
  'N5201',
  'N5202',
  'N5203',
  'N5204',
  'N5205',
  'N5206',
  'N5207',
  'N5208',
  'N5209',
  'N5210',
  'N5211',
  'N5212',
  'N5213',
  'N5214',
  'N5215',
  'N5216',
  'N5301',
  'N5401',
  'N5501',
  'N5601',
  'N5701',
  'N5801',
  'N5901',
  'N6001',
  'N6101',
  'N6201',
  'N6301',
  'N6401',
  'N6501',
  'N6601',
  'N6701',
  'N6801',
  'N6901',
  'N7001',
  'N7101',
  'N7201',
  'N7301',
  'N7401',
  'N7501',
  'N7601',
  'N7701',
  'N7801',
  'N7901',
  'N8001',
  'N8101',
  'N8201',
  'N8301',
  'N8401',
  'N8501',
  'N8601',
  'N8701',
  'N8801',
  'N8901',
  'N9001',
  'N9101',
  'N9201',
  'N9301',
  'N9401',
  'N9501',
  'N9601',
]

export const SEARCH_DISTRICT_CODES_FOR_JP_USER_INCLUDING_KO_HOSPITALS = [
  ...SEARCH_DISTRICT_CODES_FOR_JP_USER,
  'N9701', // 서울
  'N9702', // 부산
]
